export default __webpack_public_path__ + "static/media/zenyatta-ult.e686d6ac.mp3";